/**
 * The data room renewal after the SR NEXT package (MYN-247). Member-facing,
 * so never "Premium" (FR-137 wording rule).
 */
export const RENEWAL_STRINGS = {
  TITLE: 'Keep your AI Data Room',
  WHILE_OPEN: (endsAt: string) =>
    `Your SR NEXT package ends on ${endsAt}. Subscribe now and your data room carries on from that day with all your documents. Nothing is charged before then.`,
  AFTER_END: (endedAt: string, keptUntil: string) =>
    `Your SR NEXT package ended on ${endedAt}. Your documents are kept until ${keptUntil}. Subscribe to pick up where you left off.`,
  SUBSCRIBE: 'Subscribe',
  SUBSCRIBING: 'Opening checkout...',
  SUBSCRIBE_FAILED: 'Could not start the subscription. Try again.',
  PER_INTERVAL: { monthly: '/month', annual: '/year', one_time: '' },
  /** Billing & Info, after a renewal bought during the package (FR-297). */
  SCHEDULED_TITLE: 'Your data room subscription is set up',
  SCHEDULED_BODY: (planName: string, startsAt: string) =>
    `${planName} starts on ${startsAt}, when your SR NEXT package ends. Your card is saved and the first charge is taken that day.`,
} as const;
